import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const API = `${process.env.VUE_APP_API_URL}budget-revenue-items/`;

export default {
  fetch(params = {}) {
    return axios.get(API, { params, headers: buildHeaders() });
  },
  remove(id) {
    return axios.delete(`${API}${id}`, { headers: buildHeaders() });
  },
};
